import { createContext } from "react";

const DropdownContext = createContext<any>({});

export default DropdownContext;